import { defineMessages } from 'react-intl';

const messages = defineMessages({
    apploginError: {
        id:'apploginError',
        defaultMessage: '{loginError}',
        description: 'Error when the user is not able to login',
    },
    buttonSeeAllPartners: {
        id:'buttonSeeAllPartners',
        defaultMessage: 'See all',
        description: 'Text used for the "See all partners" link/button',
    },
    howItWorksHeading: {
        id:'homeHowItWorksHeading',
        defaultMessage: 'How it works',
        description: 'Heading for the "How it works" section of the home page.'
    },
    howItWorksExploreHeading: {
        id:'homeHowItWorksExploreHeading',
        defaultMessage: 'Explore',
        description: 'Heading for the "Explore" hexagon in the "How it works" section of the home page.'
    },
    howItWorksExploreText: {
        id:'homeHowItWorksExploreText',
        defaultMessage: 'Discover high-quality science content in the LabXchange library, for free.',
        description: 'Text for the "Explore" hexagon in the "How it works" section of the home page.'
    },
    howItWorksCreateHeading: {
        id:'homeHowItWorksCreateHeading',
        defaultMessage: 'Create',
        description: 'Heading for the "Create" hexagon in the "How it works" section of the home page.'
    },
    howItWorksCreateText: {
        id:'homeHowItWorksCreateText',
        defaultMessage: 'Sign up to customize a learning journey that meets your unique needs.',
        description: 'Text for the "Create" hexagon in the "How it works" section of the home page.'
    },
    howItWorksShareHeading: {
        id:'homeHowItWorksShareHeading',
        defaultMessage: 'Share',
        description: 'Heading for the "Share" hexagon in the "How it works" section of the home page.'
    },
    howItWorksShareText: {
        id:'homeHowItWorksShareText',
        defaultMessage: 'Engage with a community of educators, learners, and mentors.',
        description: 'Text for the "Share" hexagon in the "How it works" section of the home page.'
    },
    heroHeading: {
        id:'homeHeroHeading',
        defaultMessage: 'Welcome to the world\'s science classroom',
        description: 'Heading displayed in the "hero" bar at the top of the home page.',
    },
    heroText: {
        id:'homeHeroText',
        defaultMessage: 'Experience science as it should be:  a journey of bold thinking, deep imagination, and supportive community.',
        description: 'Text displayed in the "hero" bar at the top of the home page.',
    },
    heroSignUpButton: {
        id:'homeHeroSignUpButton',
        defaultMessage: 'Join for free',
        description: 'Text displayed in the "sign up" button shown on the "hero" bar at the top of the home page.',
    },
    heroExploreButton: {
        id:'homeHeroExploreButton',
        defaultMessage: 'Explore',
        description: 'Text displayed in the "explore" button shown on the "hero" bar at the top of the home page.',
    },
    exploreHeading: {
        id:'exploreHeading',
        defaultMessage: 'Start exploring now!',
        description: 'Heading for the Explore section.',
    },
    featuredItemsHeading: {
        id:'featuredItemsHeading',
        defaultMessage: 'Featured Content',
        description: 'Heading for the Featured Content section.',
    },
    sponsorHeading: {
        id:'sponsorHeading',
        defaultMessage: 'Our Sponsor',
        description: 'Heading for the Sponsor section.',
    },
    sponsorAltTag: {
        id:'sponsorAltTag',
        defaultMessage: 'Amgen Foundation',
        description: 'Alt text for the Amgen logo in the Sponsor section.',
    },
    sponsorText1: {
        id:'sponsorText1',
        defaultMessage: `LabXchange is sponsored by the Amgen
            Foundation, which seeks to advance excellence in science education
            to inspire the next generation of innovators.`,
        description: 'Text shown in Sponsor section.',
    },
    sponsorText2: {
        id:'sponsorText2',
        defaultMessage: `The Foundation, established in 1991, is an integral
            component of Amgen’s commitment to dramatically improving people’s
            lives. To date, the foundation has contributed over 325 million
            dollars to local, regional, and international nonprofit
            organizations.`,
        description: 'Text shown in Sponsor section.',
    },
    joinUsHeading: {
        id:'joinUsHeading',
        defaultMessage: 'Join the LabXchange Community',
        description: 'Heading for the Join Us section.',
    },
    promoVideoHeading: {
        id:'homePromoVideoHeading',
        defaultMessage: 'Start your journey in Science',
        description: 'Heading shown on the home page next to the promo video.'
    },
    promoVideoIsLoading: {
        id:'homePromoVideoIsLoading',
        defaultMessage: 'Video is loading',
        description: 'Text visible to screenreaders which is shown while the promo video is loading.',
    },
    promoVideoText: {
        id:'homePromoVideoText',
        defaultMessage: `Whether you're an educator, learner or science professional, it can be difficult to find the
time, resources, and support you need to reach your potential.
{linebreak}
Discover how LabXchange can help you
overcome these hurdles. We'll introduce you to the platform through the story of an educator.`,
        description: 'Text shown on the home page next to the promo video.',
    },
    amgenBannerHeading: {
        id:'amgenBannerHeading',
        defaultMessage: 'Improving LabXchange for You',
        description: 'Heading shown on amgen banner',
    },
    amgenBannerLineOne: {
        id:'amgenBannerLineOne',
        defaultMessage: 'Expanding our biotechnology, data science, and climate change content',
        description: 'Line one of the amgen banner description',
    },
    amgenBannerLineTwo: {
        id:'amgenBannerLineTwo',
        defaultMessage: 'Making content available in 30+ languages',
        description: 'Line two of the amgen banner description',
    },
    amgenBannerLineThree: {
        id:'amgenBannerLineThree',
        defaultMessage: 'Launching a teacher ambassador network',
        description: 'Line Three of the amgen banner description',
    },
    amgenBannerLineFour: {
        id:'amgenBannerLineFour',
        defaultMessage: 'Adding content that addresses racial inequity in STEM',
        description: 'Line Four of the amgen banner description',
    },
    amgenBannerLineFive: {
        id:'amgenBannerLineFive',
        defaultMessage: 'Enhancing content for middle schoolers',
        description: 'Line Five of the amgen banner description',
    },
    amgenVideoHeading: {
        id:'amgenVideoHeading',
        defaultMessage: 'Reinventing Science Education',
        description: 'Heading shown on amgen banner video',
    },
    amgenVideoDescription: {
        id:'amgenVideoDescription',
        defaultMessage: `Whether you’re an educator, learner, or science professional, it can be difficult
        to find the time, resources, and support you need to reach your potential.
        {linebreak}
        LabXchange can help you overcome these hurdles. We’re a science education community 20 million strong.`,
        description: 'Text shown on the home page on the next to the amgen video',
    },
    learnMoreButtonLabel: {
        id:'learnMoreButtonLabel',
        defaultMessage: 'Learn more',
        description: 'Label for a learn more button',
    },
});

export default messages;
